class AstraBookingHandler {
    constructor() {
        this.rest_url = astra_booking.rest_api;
        this.nonce = astra_booking.wp_rest;
        this.cacheDom();
        this.bindEvents();
    }

    // Cache DOM elements
    cacheDom() {
      this.timeSlots = document.querySelectorAll('.time:not(.booked)');
        
        this.bookingPopupOverlay = document.getElementById('bookingPopupOverlay');
        this.bookingPopup = document.getElementById('bookingPopup');
        this.bookingForm = document.getElementById('bookingForm');
        this.form_doctorText = document.getElementById('form-doctor');
        this.form_timeText = document.getElementById('form-time');
        this.form_dateText = document.getElementById('form-date');
        this.closePopup = document.getElementById('closePopup');

        this.closePopup.addEventListener('click', () => {
            this.bookingPopupOverlay.style.display = 'none';
        }
    );

        // Form inputs
        this.formInputs = {
            doctor: document.getElementById('hidden-doctor'),
            time: document.getElementById('hidden-time'),
            date: document.getElementById('hidden-date'),
            service: document.getElementById('hidden-service'),
            firstName: document.getElementById('firstName'),
            lastName: document.getElementById('lastName'),
            email: document.getElementById('email'),
            phone: document.getElementById('phone'),
            consent: document.getElementById('consent'),
        };

        this.submitButton = document.getElementById('submit');
    }

    // Bind event listeners
    bindEvents() {
        this.timeSlots.forEach((timeSlot) => {
            timeSlot.addEventListener('click', this.openBookingPopup.bind(this));
        });

        this.bookingForm.addEventListener('submit', this.submitForm.bind(this));
    }

    // Open the booking popup and populate form with time slot data
    openBookingPopup(e) {
        const timeSlot = e.target.closest('.time');
        const { time, doctor, service, date, doctor_name } = timeSlot.dataset;

        console.log(timeSlot , 'time');
        
        console.log({
            time,
            doctor,
            service,
            date,
            doctor_name
        });
        

 

        // Validate the data, alert if any information is missing
        if (!time || !doctor || !service || !date) {
            alert('There was an error. Please contact support at info@carenashville.com');
            return;
        }

        // Populate hidden form inputs
        this.formInputs.doctor.value = doctor;
        this.formInputs.time.value = time;
        this.formInputs.date.value = date;
        this.formInputs.service.value = service;

        // Show the booking popup
        this.bookingPopupOverlay.style.display = 'flex';

        // Update the form text
        this.form_doctorText.textContent = doctor_name;
        this.form_timeText.textContent = time;
        this.form_dateText.textContent = date;
    }

    // Handle form submission
    async submitForm(e) {
        e.preventDefault();

        // Validate the form
        if (!this.validateForm()) {
            return;
        }

        // Prepare the form data
        const data = new FormData(this.bookingForm);
        const formData = {};

        for (let key of data.keys()) {
            formData[key.replace('hidden-', '')] = data.get(key);
        }

        try {
            const response = await fetch(`${this.rest_url}astra-booking/v1/booking`, {
                method: 'POST',
                headers: {
                    'X-WP-Nonce': this.nonce,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            const jsonResponse = await response.json();
            // Handle the response
            if (response.ok) {
                

                console.log(jsonResponse, 'response');
                
                if (jsonResponse.status_code === 200) {
                    alert('Booking successful');
                    this.bookingPopupOverlay.style.display = 'none';
                    this.bookingForm.reset();
                    window.location.href = `/booking-thank-you/?id=${jsonResponse.id}`;
                } else {
                     alert(jsonResponse.message);
                }
            } else {
                 alert(jsonResponse.message);
            }
        } catch (error) {
            console.error('Form submission error:', error);
        }
    }

    // Validate the form inputs
    validateForm() {
        const { firstName, lastName, email, phone, consent } = this.formInputs;
        let isValid = true;
        let error = '';

        if (!firstName.value || !lastName.value || !email.value || !phone.value || !consent.checked) {
            isValid = false;
            error = 'Please fill out all fields and check the consent box';
        }

        // Email validation
        const emailRegEx = /\S+@\S+\.\S+/;
        if (!emailRegEx.test(email.value)) {
            isValid = false;
            error = 'Please enter a valid email address';
        }

        // Phone number validation (10 digits)
        const phoneRegEx = /^(?:\+?1[-.\s]?)?(?:\(?(\d{3})\)?[-.\s]?)?(\d{3})[-.\s]?(\d{4})$/;
        if (!phoneRegEx.test(phone.value)) {
            isValid = false;
            error = 'Please enter a valid phone number';
        }

        if (!isValid) {
            alert(error);
        }

        return isValid;
    }
}
exports.AstraBookingHandler = AstraBookingHandler;
